export const App_Labels = {
    System: {
        Pt: {
            Yes: "Sim",
            No: "Não",
            And: "E",
            and: "e",
            Attention: "Atenção",
            Return: "Voltar",
            Error: "Erro",
            SuccessOperation: "Operação realizada com sucesso!",
            FailedOperation: "Operação falhou!",
            SuccessUpdated: "Atualizado com sucesso!",
            Update: "Atualizar",
            SuccessRemoved: "Removido com sucesso!",
            Warning: "Aviso",
            Save: "Salvar",
            Finish: "Concluir",
            Preferences: "Preferências",
            preferences: "preferências",
            Delete: "Excluir",
            Deactivate: "Desativar",
            Activate: "Ativar",
            Proceed: "Prosseguir",
            Cancel: "Cancelar",
            Close: "Fechar",
            Email: "E-mail",
            email: "e-mail",
            EmailInvalid: "E-mail inválido",            
            Password: "Senha",
            PasswordConfirmation: "Confimar Senha",
            password: "senha",
            PasswordForgot: "Esqueci minha senha",
            PasswordNew: "Nova Senha",
            PasswordRequirements: "A senha deve ter de 8 a 35 caracteres, conter letras minúsculas e maiúsculas, números e pelo menos um dos caracteres especiais !#@*.",
            PasswordCheckPostalCode: "Foi enviado uma nova senha de recuperação para o e-mail $placeholder. Não se preocupe, depois poderá altera-la na administração de sua conta.",
            PasswordChange: "Trocar a senha",
            Enter: "Entrar",
            Exit: "Sair",
            Of: "De",
            of: "de",
            Characters: "caracteres",
            CharactersLengthOf: "de $placeholder caracteres",
            Select: "Selecione",
            Search: "Pesquisar",
            Find: "Procurar",
            FillWith: "Preencher com ",
            FailedAskForData: "Para prosseguir é necessário informar os dados solicitados.",
            Loading: "Aguarde, carregando...",
            AskForDelete: "Tem certeza de que deseja excluir este item?",
            MicrosoftLogin: "Entrar com Microsoft",
            RecoveryCodeLabelHeader: "Informe o e-mail com o qual deseja iniciar o processo de recuperação de senha.",  
            RecoveryCodeAskfor: "Solicitar código de recuperação",
            recoveryCode: "código",
            RecoveryCodeEnterWith: "Entrar com código",
            RecoveryCodeHeaderAskFor: "Informe o código de recuperação para que o sistema envie uma nova senha.",
            RecoveryCodeCheckPostalCode: "Foi enviado um código de recuperação para o e-mail $placeholder. Verifique em sua caixa postal para prosseguir com a redefinição de senha.",
            RecoveryCodeInvalid: "Não foi possível concluir a ação. O código está expirado ou inválido. Por favor, repita o processo. Caso o problema persista, entre em contato com o suporte.",            
            InvalidCredentials: "E-mail ou senha inválidos. Verifique os dados e tente novamente.",
            AutoLoginError: "Ocorreu um erro ao tentar fazer login com o método selecionado. Tente outro método. Caso o problema persista, entre em contato com o suporte técnico.",           
            MenuGreetings: "Oi, $placeholder! Que bom te ver!",
            MenuAccountPreferences: "Configurar as preferências da conta",
            LoginLabelHeader: "Clique no botão abaixo para entrar com sua conta.",
            AskForConfirmation: "Você realmente deseja confirmar a ação selecionada?",          
            ErrorGeneric: "Ocorreu um erro, caso o problema persista entre em contato com o suporte.",          
            WarningListAlreadyExists: "Esse item já existe na listagem!",
            Actions: "Ações",
            Tracking: "Rastreio",
            History: "Histórico",
            Create: "Criar",
            CreatedBy: "Criado por",
            UpdatedBy: "Atualizado por",
            CreatedDate: "Data de criação",
            UpdatedDate: "Data de atualização",
            Identifier: "Identificador",
            Edit: "Editar",
            WarningQuestionProceed: "Deseja prosseguir com essa ação?",
            WarningSelectMore:"Selecione pelo menos um registro antes de prosseguir",
            WarningFillMandatoryData:"Há campos obrigatórios não preenchidos, verifique os campos desse registro antes de prosseguir",
            WarningFillStatusData: "Selecione um status desse registro antes de prosseguir",            
            Name: "Nome",
            LastName: "Sobrenome",
            Profile: "Perfil",
            Year: "Ano",
            New: "Novo",
            Users: "Usuários",
            Configurations: "Configurações",
            Administration: "Administração",
            Contents: "Conteúdos",
            Content: "Conteúdo",
            Approve: "Aprovar",
            Disapprove: "Reprovar",
            Relationships: "Relacionamentos",
            Relationships: "Relacionamento",
            Status: "Status",
            Pending: "Pendente",
            Finished: "Concluído",
            Observation: "Observação",
            Reference: "Referência",
            Tip: "Dica",
            ChangesNotSavedWarning: "Alterações não salvas",
            Portuguese: "Português",
            English: "Inglês",            
            Spanish: "Espanhol",
            Order: "Ordem",
            Size: "Tamanho",
            Languages: "Linguagens",
            UserConfigWarningLanguageLabel: "Idioma dos avisos",
            UserConfigHomePageLabel: "Configuração da página inicial",
            Features: "Functionalidades",
            Row: "Linha",
            Column: "Coluna",
            Width: "Largura",
            Height: "Altura",
            ExportPdf: "Exportar PDF",
            Send: "Enviar",
            TicketSupportLabel: "Obter ajuda",
            TicketSupportHeader: "Bem vindo à ajuda integrada do ISE",
            TicketSupportBody: "Descreva sua solicitação e envie para nosso time para análise.",
            TicketSupportLabelCategory: "Selecione a categoria",
            TicketSupportLabelCategoryOptionSuggestion: "Sugestão",
            TicketSupportLabelCategoryOptionHelp: "Ajuda",
            TicketSupportLabelRequest: "Descreva a solicitação",
            TicketSupportReturnHeader: "Obrigado por nos enviar sua solicitação!",
            TicketSupportReturnBody: "Sua mensagem é muito importante e nossa equipe de especialistas de suporte entrará em contato com você o mais breve possível.",
            NotFound: "Página não encontrada",
            WarningPasswordDoesNotMatch: "A senha e a confirmação de senha não são iguais.",
            ErrorTimeout: "Erro de tempo limite da solicitação",
            ErrorNetwork: "Erro de rede na solicitação",
            ErrorUnexpected: "Erro de rede na solicitação",
            See: "Ver",
            until: "até",
            InProgress: "Em andamento",
            Notify: "Notificar",
            HomeConfigLabelText: "Construa sua página inicial com os items que deseja, nas preferências de sua conta.", 
            Open: "Aberto",
        },
        En: {
            Yes: "Yes",
            No: "No",
            And: "And",
            and: "and",
            Attention: "Attention",
            Return: "Back",
            Error: "Error",
            SuccessOperation: "Operation completed successfully!",
            FailedOperation: "Operation failed!",
            SuccessUpdated: "Updated successfully!",
            Update: "Update",
            SuccessRemoved: "Removed successfully!",
            Warning: "Warning",
            Save: "Save",
            Finish: "Finish",
            Preferences: "Preferences",
            preferences: "preferences",
            Delete: "Delete",
            Deactivate: "Deactivate",
            Activate: "Activate",
            Proceed: "Proceed",
            Cancel: "Cancel",
            Close: "Close",
            Email: "Email",
            email: "email",
            EmailInvalid: "Invalid email",            
            Password: "Password",
            PasswordConfirmation: "Confirm Password",
            password: "password",
            PasswordForgot: "Forgot my password",
            PasswordNew: "New Password",
            PasswordRequirements: "The password must be between 8 and 35 characters long, contain lowercase and uppercase letters, numbers, and at least one of the special characters !#@*.",
            PasswordCheckPostalCode: "A new recovery password has been sent to the email $placeholder. Don't worry, you can change it later in your account settings.",
            PasswordChange: "Change password",
            Enter: "Sign In",
            Exit: "Sign Out",
            Of: "Of",
            of: "of",
            Characters: "characters",
            CharactersLengthOf: "of $placeholder characters",
            Select: "Select",
            Search: "Search",
            Find: "Find",
            FillWith: "Fill with ",
            FailedAskForData: "To proceed, you must provide the requested information.",
            Loading: "Please wait, loading...",
            AskForDelete: "Are you sure you want to delete this item?",
            MicrosoftLogin: "Sign in with Microsoft",
            RecoveryCodeLabelHeader: "Enter the email you wish to use to start the password recovery process.",  
            RecoveryCodeAskfor: "Request recovery code",
            recoveryCode: "code",
            RecoveryCodeEnterWith: "Enter with code",
            RecoveryCodeHeaderAskFor: "Enter the recovery code so the system can send a new password.",
            RecoveryCodeCheckPostalCode: "A recovery code has been sent to the email $placeholder. Please check your inbox to proceed with the password reset.",
            RecoveryCodeInvalid: "Could not complete the action. The code is expired or invalid. Please repeat the process. If the problem persists, contact support.",            
            InvalidCredentials: "Invalid email or password. Please check your details and try again.",
            AutoLoginError: "An error occurred while trying to log in with the selected method. Please try another method. If the problem persists, contact technical support.",           
            MenuGreetings: "Hi, $placeholder! Good to see you!",
            MenuAccountPreferences: "Configure account preferences",
            LoginLabelHeader: "Click the button below to log in with your account.",
            AskForConfirmation: "Are you sure you want to confirm the selected action?",          
            ErrorGeneric: "An error occurred. If the problem persists, please contact support.",          
            WarningListAlreadyExists: "This item already exists in the list!",
            Actions: "Actions",
            Tracking: "Tracking",
            History: "History",
            Create: "Create",
            CreatedBy: "Created by",
            UpdatedBy: "Updated by",
            CreatedDate: "Creation date",
            UpdatedDate: "Update date",
            Identifier: "Identifier",
            Edit: "Edit",
            WarningQuestionProceed: "Do you want to proceed with this action?",
            WarningSelectMore: "Select at least one record before proceeding",
            WarningFillMandatoryData: "There are required fields that have not been filled out. Please check the fields for this record before proceeding",
            WarningFillStatusData: "Select a status for this record before proceeding",            
            Name: "Name",
            LastName: "Last Name",
            Profile: "Profile",
            Year: "Year",
            New: "New",
            Users: "Users",
            Configurations: "Settings",
            Administration: "Administration",
            Contents: "Contents",
            Content: "Content",
            Approve: "Approve",
            Disapprove: "Disapprove",
            Relationships: "Relationships",
            Status: "Status",
            Pending: "Pending",
            Finished: "Completed",
            Observation: "Observation",
            Reference: "Reference",
            Tip: "Tip",
            ChangesNotSavedWarning: "Unsaved changes",
            Portuguese: "Portuguese",
            English: "English",            
            Spanish: "Spanish",
            Order: "Order",
            Size: "Size",
            Languages: "Languages",
            UserConfigWarningLanguageLabel: "Notification language",
            UserConfigHomePageLabel: "Homepage configuration",
            Features: "Features",
            Row: "Row",
            Column: "Column",
            Width: "Width",
            Height: "Height",
            ExportPdf: "Export PDF",
            Send: "Send",
            TicketSupportLabel: "Get help",
            TicketSupportHeader: "Welcome to ISE integrated support",
            TicketSupportBody: "Describe your request and send it to our team for review.",
            TicketSupportLabelCategory: "Select a category",
            TicketSupportLabelCategoryOptionSuggestion: "Suggestion",
            TicketSupportLabelCategoryOptionHelp: "Help",
            TicketSupportLabelRequest: "Describe the request",
            TicketSupportReturnHeader: "Thank you for sending us your request!",
            TicketSupportReturnBody: "Your message is very important, and our team of support specialists will contact you as soon as possible.",            
            NotFound: "Page not found",
            WarningPasswordDoesNotMatch: "The password and the password confirmation are not the same.",
            ErrorTimeout: "Request timed out error",
            ErrorNetwork: "Request network error",
            ErrorUnexpected: "Request network error",
            See: "See",
            until: "until",
            InProgress: "In Progress",
            Notify: "Notify",
            HomeConfigLabelText: "Build your homepage with the items you want, in your account preferences.", 
            Open: "Open",
        },
        Es: {
            Yes: "Sí",
            No: "No",
            And: "Y",
            and: "y",
            Attention: "Atención",
            Return: "Volver",
            Error: "Error",
            SuccessOperation: "¡Operación realizada con éxito!",
            FailedOperation: "¡La operación ha fallado!",
            SuccessUpdated: "¡Actualizado con éxito!",
            Update: "Actualizar",
            SuccessRemoved: "¡Eliminado con éxito!",
            Warning: "Aviso",
            Save: "Guardar",
            Finish: "Concluir",
            Preferences: "Preferencias",
            preferences: "preferencias",
            Delete: "Eliminar",
            Deactivate: "Desactivar",
            Activate: "Activar",
            Proceed: "Proceder",
            Cancel: "Cancelar",
            Close: "Cerrar",
            Email: "Correo electrónico",
            email: "correo electrónico",
            EmailInvalid: "Correo electrónico inválido",            
            Password: "Contraseña",
            PasswordConfirmation: "Confirmar contraseña",
            password: "contraseña",
            PasswordForgot: "Olvidé mi contraseña",
            PasswordNew: "Nueva contraseña",
            PasswordRequirements: "La contraseña debe tener entre 8 y 35 caracteres, contener letras mayúsculas y minúsculas, números y al menos uno de los caracteres especiales !#@*.",
            PasswordCheckPostalCode: "Se ha enviado una nueva contraseña de recuperación al correo electrónico $placeholder. No se preocupe, podrá cambiarla más adelante en la administración de su cuenta.",
            PasswordChange: "Cambiar contraseña",
            Enter: "Entrar",
            Exit: "Salir",
            Of: "De",
            of: "de",
            Characters: "caracteres",
            CharactersLengthOf: "de $placeholder caracteres",
            Select: "Seleccione",
            Search: "Buscar",
            Find: "Buscar",
            FillWith: "Rellenar con ",
            FailedAskForData: "Para proceder es necesario completar los datos solicitados.",
            Loading: "Espere, cargando...",
            AskForDelete: "¿Está seguro de que desea eliminar este elemento?",
            MicrosoftLogin: "Iniciar sesión con Microsoft",
            RecoveryCodeLabelHeader: "Ingrese el correo electrónico con el que desea iniciar el proceso de recuperación de contraseña.",  
            RecoveryCodeAskfor: "Solicitar código de recuperación",
            recoveryCode: "código",
            RecoveryCodeEnterWith: "Entrar con código",
            RecoveryCodeHeaderAskFor: "Ingrese el código de recuperación para que el sistema envíe una nueva contraseña.",
            RecoveryCodeCheckPostalCode: "Se ha enviado un código de recuperación al correo electrónico $placeholder. Verifique su bandeja de entrada para proceder con el restablecimiento de la contraseña.",
            RecoveryCodeInvalid: "No se pudo completar la acción. El código ha expirado o no es válido. Por favor, repita el proceso. Si el problema persiste, contacte con el soporte técnico.",            
            InvalidCredentials: "Correo electrónico o contraseña inválidos. Verifique los datos e intente nuevamente.",
            AutoLoginError: "Ocurrió un error al intentar iniciar sesión con el método seleccionado. Intente con otro método. Si el problema persiste, contacte con el soporte técnico.",           
            MenuGreetings: "¡Hola, $placeholder! ¡Qué bueno verte!",
            MenuAccountPreferences: "Configurar las preferencias de la cuenta",
            LoginLabelHeader: "Haga clic en el botón de abajo para entrar con su cuenta.",
            AskForConfirmation: "¿Realmente desea confirmar la acción seleccionada?",          
            ErrorGeneric: "Ocurrió un error. Si el problema persiste, contacte con el soporte técnico.",          
            WarningListAlreadyExists: "¡Este elemento ya existe en la lista!",
            Actions: "Acciones",
            Tracking: "Rastreo",
            History: "Historial",
            Create: "Crear",
            CreatedBy: "Creado por",
            UpdatedBy: "Actualizado por",
            CreatedDate: "Fecha de creación",
            UpdatedDate: "Fecha de actualización",
            Identifier: "Identificador",
            Edit: "Editar",
            WarningQuestionProceed: "¿Desea proceder con esta acción?",
            WarningSelectMore: "Seleccione al menos un registro antes de proceder",
            WarningFillMandatoryData: "Hay campos obligatorios sin completar, verifique los campos de este registro antes de proceder",
            WarningFillStatusData: "Seleccione un estado para este registro antes de proceder",            
            Name: "Nombre",
            LastName: "Apellido",
            Profile: "Perfil",
            Year: "Año",
            New: "Nuevo",
            Users: "Usuarios",
            Configurations: "Configuraciones",
            Administration: "Administración",
            Contents: "Contenidos",
            Content: "Contenido",
            Approve: "Aprobar",
            Disapprove: "Reprobar",
            Relationships: "Relaciones",
            Status: "Estado",
            Pending: "Pendiente",
            Finished: "Completado",
            Observation: "Observación",
            Reference: "Referencia",
            Tip: "Sugerencia",
            ChangesNotSavedWarning: "Cambios no guardados",
            Portuguese: "Portugués",
            English: "Inglés",            
            Spanish: "Español",
            Order: "Orden",
            Size: "Tamaño",
            Languages: "Idiomas",
            UserConfigWarningLanguageLabel: "Idioma de los avisos",
            UserConfigHomePageLabel: "Configuración de la página de inicio",
            Features: "Funcionalidades",
            Row: "Fila",
            Column: "Columna",
            Width: "Ancho",
            Height: "Altura",
            ExportPdf: "Exportar PDF",
            Send: "Enviar",
            TicketSupportLabel: "Obtener ayuda",
            TicketSupportHeader: "Bienvenido al soporte integrado de ISE",
            TicketSupportBody: "Describa su solicitud y envíela a nuestro equipo para su análisis.",
            TicketSupportLabelCategory: "Seleccione una categoría",
            TicketSupportLabelCategoryOptionSuggestion: "Sugerencia",
            TicketSupportLabelCategoryOptionHelp: "Ayuda",
            TicketSupportLabelRequest: "Describa la solicitud",
            TicketSupportReturnHeader: "¡Gracias por enviarnos su solicitud!",
            TicketSupportReturnBody: "Su mensaje es muy importante y nuestro equipo de especialistas de soporte se pondrá en contacto con usted lo antes posible.",            
            NotFound: "Página no encontrada",
            WarningPasswordDoesNotMatch: "La contraseña y la confirmación de la contraseña no son lo mismo.",
            ErrorTimeout: "Error de tiempo de espera de la solicitud",
            ErrorNetwork: "Error de red en la solicitud",
            ErrorUnexpected: "Error de red en la solicitud",
            See: "Ver",
            until: "hasta",
            InProgress: "En curso",
            Notify: "Notificar",
            HomeConfigLabelText: "Crea tu página de inicio con los elementos que desees, en las preferencias de tu cuenta.", 
            Open: "Abierto",
        }
    },
    Business: {
        Pt: {
            ApplicationName: "ISEFeedBack",
            Department: "Departamento",
            Departments: "Departamentos",
            DepartmentListWarning_0: "Departamentos ainda não carregados",
            FeedbackPageHeader: "Período vigente",            
            Hiring: "Contratação",
            HiringDate: "Data de contratação",
            Contributor: "Colaborador",
            LastFeedBack: "Ultimo feedback",
            FilledIn: "Preenchido",    
            MenuHeaderBlockMain: "Principal",
            MenuHeaderBlockReports: "Relatórios",
            MenuHeaderBlockAdministration: "Administração",
            MenuBind: "Vínculos Gestor-Colaborador",   
            MenuFeedbackScript: "Roteiro de feedback",
            MenuDashboard: "Painel de feedback",
            MenuFeedbackReport: "Relatório de Feedbacks",
            HeaderPageBind: "Gerenciamento de vínculos",
            Bind: "Vínculos",
            BindApproval: "Aprovação de vínculos",
            AdminPageHeader: "Gerenciamento de perfil de usuário",
            ContentPageHeader: "Gerenciamento de conteúdo",
            UserPageHeader: "Gerenciamento de usuários",
            DepartmentPageHeader: "Gerenciamento de departamentos",
            AssignmentPageHeader: "Gerenciamento de funções",
            CyclePageHeader: "Gerenciamento de Ciclos",
            PeriodLabelPageHeader: "Gerenciamento de rótulo de período",
            Cycles: "Ciclos",
            Periods: "Períodos",
            Period: "Período",
            PeriodStartDate: "Data de início do período",
            PeriodEndDate: "Data de final do período",            
            Stages: "Estágios",
            Stage: "Estágio",
            DevelopmentStagePageHeader: "Gerenciamento de estágio de desenvolvimento",
            Mentees: "Colaboradores",
            Mentors: "Gestores",
            Mentor: "Gestor",
            TableHeaderPersonData: "Dados da pessoa",
            TableHeaderPersonMentorData: "Dados do Gestor",
            TableHeaderPersonMenteeData: "Dados do Colaborador",
            TableHeaderCycleData: "Dados do Ciclo",
            TableHeaderDevelopmentStageData: "Dados do estágio de desenvolvimento",
            TableHeaderPeriodLabel: "Dados do label do período",
            TableHeaderContentFeedback: "Dados do conteúdo do feedback",
            TableHeaderDepartmentData: "Dados do departamento",
            TableHeaderAssignmentData: "Dados da função",
            TableStateNotStarted: "Não inciado",
            ReferenceYear: "Ano de referência",
            PeriodDescription: "Descrição do período",
            ContentOrder: "Ordenação do conteúdo",
            WarningMessage0: "Selecione um perfil para esse registro antes de prosseguir",
            WarningMessage1: "Insira um nome para esse registro antes de prosseguir",
            WarningMessage2: "Insira um nome para o período para esse registro antes de prosseguir",
            WarningMessage3: "Selecione um rótulo de período para ser selecionado nas busca rápida para o período aplicando ao descritivo para esse registro antes de prosseguir",
            WarningMessage4: "Selecione um status para esse período para esse registro antes de prosseguir",            
            WarningMessage5: "A data de início é superior a data de término, faça a correção desse registro de nome: $placeholder antes de prosseguir",
            WarningMessage6: "Insira um ano para esse registro antes de prosseguir",  
            WarningMessage7: "Selecione um label de período para ser selecionado nas busca rápida para o período aplicando ao descritivo para esse registro antes de prosseguir",
            WarningMessage8: "Selecione um departamento para esse registro antes de prosseguir",            
            WarningMessage9: "Descreva a função para o colaborador",   
            WarningMessage10: "Descreva a área para o colaborador", 
            WarningMessage11: "Selecione uma data para esse feedback", 
            WarningMessage12: "Selecione um gestor responsável para esse colaborador",
            WarningMessage13: "Selecione um estágio de desenvolvimento do colaborador",
            WarningMessage14: "Selecione uma data de contratação do colaborador",            
            FieldSelectUser: "Selecione um usuário",
            BindPageLabel0: "Selecione os colaboradores para este gestor",
            BindPageLabel1: "Mesmo departamento",
            BindPageLabel2: "Todos da organização",
            BindPageLabel3: "Pessoas vinculadas como colaboradores",
            Script: "Roteiro",
            Function: "Função",
            Area: "Área",
            ResponsibleMentor: "Gestor responsável",
            FeedbackFormDateFeed: "Data da conversa",
            FeedbackFormHeader0: "Informações gerais",
            FeedbackFormHeader1: "Percepções do ciclo",
            FeedbackFormHeader2: "Plano de desenvolvimento",
            FeedbackFormHeader3: "Estágio atual de desenvolvimento",
            FeedbackFormHeader4: "Próximos Passos",
            FeedbackFormLabel0: "Percepções do colaborador sobre o período",
            FeedbackFormLabel1: "Percepções do gestor sobre o período",
            FeedbackFormLabel2: "Desenvolvimento formal, novos projetos e objetivos para o próximo período",
            FeedbackFormLabel3: "Visível somente ao gestor",
            FeedbackFormLabel4: "Campo confidencial do gestor",
            FeedbackFormLabel5: "Este campo é privado e acessível apenas a você.",
            FeedbackFormLabel6: "Utilize este campo para descrever o estágio atual de desenvolvimento do colaborador, os principais pontos observados e os próximos passos para sua evolução.",            
            FeedbackFormLabel7: "Feedback de",            
            FeedbackFormLabel8: "Estágio anterior",            
            FeedbackFormLabel9: "Campo confidencial do gestor.",        
            FeedbackFormLabel10: "Deseja exportar as notas privadas?",
            SelectDateLabel0: "Selecione a data de início",
            SelectDateLabel1: "Selecione a data",
            ContentDisplayBlank: "Selecione uma opção para display",
            PDFFeedBackFooterLabel0: "Documento gerado para acompanhamento interno.",
            PDFFeedBackFooterLabel1: "e Desenvolvimento",
            TableNoOpenCycle: "Não há ciclo em aberto",
            ReportPageHeader_0: "Painel operacional",
            ReportPageLabel0: "Conclusão por departamento",
            ReportPageLabel1: "Selecione um ciclo antes de consultar",
            ReportPageLabel2: "Você tem feedbacks para realizar do colaborador",
            ReportPageLabel2: "Você não concluiu o feedback do colaborador",
            ReportNotificationTemplate1: "Mensagem de ISEFeedBack",
            ReportNotificationTemplate2: "O colaborador |placeholder| não possui feedback concluído em nossa plataforma",
            DepartmentCurrent: "Departamento atual",
            Cycle: "Ciclo",
            UserHistoryTooltip: "Marque essa opção para habilitar o histórico do colaborador para todos os gestores do mesmo",
            UserManagerTooltip: "Marque essa opção para a pessoa aparecer como gestor na listagem do cadastro de vínculos",
            AccessDeniedContent: "Você não possui acesso a essa funcionalidade",
            Assignment: "Função",
            DepartmentAssignmentBind: "Funções vinculadas no departamento",
            DepartmentOld: "Departamento anterior",
            AssignmentCurrent: "Função atual",
            AssignmentOld: "Função anterior",
            DevelopmentStageCurrent: "Estágio atual",
            DevelopmentStageFeedback: "Estágio do feedback",
            LoadingMessage0: "Iniciando o processo...",
            LoadingMessage1: "Construindo parâmetros...",
            LoadingMessage2: "Compactando os dados...",
            LoadingMessage3: "Preparando credenciais...",
            LoadingMessage4: "Enviando solicitação...",
            LoadingMessage5: "Recebendo solicitação...",
            LoadingMessage6: "Validando credenciais...",
            LoadingMessage7: "Validando perfil...",
            LoadingMessage8: "Descompactando os dados...",
            LoadingMessage9: "Validando formato...",
            LoadingMessage10: "Buscando os dados...",
            LoadingMessage11: "Preparando para descriptografar os dados...",
            LoadingMessage12: "Descriptografando os dados...",
            LoadingMessage13: "Descriptografando os dados...",
            LoadingMessage14: "Aguarde enquanto descriptografamos os dados...",
            LoadingMessage15: "Aguarde enquanto descriptografamos os dados...",
            LoadingMessage16: "Dados descriptografados com sucesso...",
            LoadingMessage17: "Processando e organizando os dados...",
            LoadingMessage18: "Compactando os dados...",
            LoadingMessage19: "Preparando a interface...",
            LoadingMessage20: "Preparando a interface...",            
        },
        En: {
            ApplicationName: "ISEFeedBack",
            Department: "Department",
            Departments: "Departments",
            DepartmentListWarning_0: "Departments not yet loaded",
            FeedbackPageHeader: "Current period",            
            Hiring: "Hiring",
            HiringDate: "Hiring date",
            Contributor: "Employee",
            LastFeedBack: "Last feedback",
            FilledIn: "Filled in",    
            MenuHeaderBlockMain: "Main",
            MenuHeaderBlockReports: "Reports",
            MenuHeaderBlockAdministration: "Administration",
            MenuBind: "Manager-Employee Links",   
            MenuFeedbackScript: "Feedback template",
            MenuDashboard: "Feedback dashboard",
            MenuFeedbackReport: "Feedback Report",
            HeaderPageBind: "Link management",
            Bind: "Links",
            BindApproval: "Link approval",
            AdminPageHeader: "User profile management",
            ContentPageHeader: "Content management",
            UserPageHeader: "User management",
            DepartmentPageHeader: "Department Management",
            AssignmentPageHeader: "Assignment Management",            
            CyclePageHeader: "Cycle management",
            PeriodLabelPageHeader: "Period label management",
            Cycles: "Cycles",
            Periods: "Periods",
            Period: "Period",
            PeriodStartDate: "Period start date",
            PeriodEndDate: "Period end date",            
            Stages: "Stages",
            Stage: "Stage",
            DevelopmentStagePageHeader: "Development stage management",
            Mentees: "Employees",
            Mentors: "Managers",
            Mentor: "Manager",
            TableHeaderPersonData: "Person details",
            TableHeaderPersonMentorData: "Manager details",
            TableHeaderPersonMenteeData: "Employee details",
            TableHeaderCycleData: "Cycle details",
            TableHeaderDevelopmentStageData: "Development stage details",
            TableHeaderPeriodLabel: "Period label details",
            TableHeaderContentFeedback: "Feedback content details",
            TableHeaderDepartmentData: "Department details",
            TableHeaderAssignmentData: "Assignment details",
            TableStateNotStarted: "Not started",
            ReferenceYear: "Reference year",
            PeriodDescription: "Period description",
            ContentOrder: "Content ordering",
            WarningMessage0: "Select a profile for this record before proceeding",
            WarningMessage1: "Enter a name for this record before proceeding",
            WarningMessage2: "Enter a period name for this record before proceeding",
            WarningMessage3: "Select a period label to be available in the quick search for the period applied to the description for this record before proceeding",
            WarningMessage4: "Select a status for this period for this record before proceeding",            
            WarningMessage5: "The start date is later than the end date. Please correct this record named: $placeholder before proceeding",
            WarningMessage6: "Enter a year for this record before proceeding",  
            WarningMessage7: "Select a period label to be available in the quick search for the period applied to the description for this record before proceeding",
            WarningMessage8: "Select a department for this record before proceeding",            
            WarningMessage9: "Describe the role for the employee",   
            WarningMessage10: "Describe the area for the employee", 
            WarningMessage11: "Select a date for this feedback", 
            WarningMessage12: "Select a responsible manager for this employee",
            WarningMessage13: "Select a development stage for the employee",
            WarningMessage14: "Select a start date for the employee",
            FieldSelectUser: "Select a user",
            BindPageLabel0: "Select the employees for this manager",
            BindPageLabel1: "Same department",
            BindPageLabel2: "All from organization",
            BindPageLabel3: "People linked as employees",
            Script: "Template",
            Function: "Role",
            Area: "Area",
            ResponsibleMentor: "Responsible manager",
            FeedbackFormDateFeed: "Discussion date",
            FeedbackFormHeader0: "General information",
            FeedbackFormHeader1: "Cycle insights",
            FeedbackFormHeader2: "Development plan",
            FeedbackFormHeader3: "Current stage of development",
            FeedbackFormHeader4: "Next Steps",
            FeedbackFormLabel0: "Employee's insights regarding the period",
            FeedbackFormLabel1: "Manager's insights regarding the period",
            FeedbackFormLabel2: "Formal development, new projects, and objectives for the next period",
            FeedbackFormLabel3: "Visible only to the manager",
            FeedbackFormLabel4: "Manager's confidential field",
            FeedbackFormLabel5: "This field is private and accessible only to you.",
            FeedbackFormLabel6: "Use this field to describe the employee's current stage of development, the main points observed, and the next steps for their advancement.",            
            FeedbackFormLabel7: "Feedback of", 
            FeedbackFormLabel8: "Previous status", 
            FeedbackFormLabel9: "Confidential field of the manager.", 
            FeedbackFormLabel10: "Do you want to export the private notes?",
            SelectDateLabel0: "Select starting date", 
            SelectDateLabel1: "Select a data",
            ContentDisplayBlank: "Select a option for display",         
            PDFFeedBackFooterLabel0: "Document generated for internal monitoring.",
            PDFFeedBackFooterLabel1: "and Development",            
            TableNoOpenCycle: "There is no cycle open",
            ReportPageHeader_0: "Operational dashboard",  
            ReportPageLabel0: "Conclusion by department",
            ReportPageLabel1: "Select a cycle before querying",
            ReportPageLabel2: "You have not completed the employee feedback",
            ReportNotificationTemplate1: "ISEFeedBack Message",
            ReportNotificationTemplate2: "The employee |placeholder| does not have completed feedback on our platform",
            DepartmentCurrent: "Current department", 
            Cycle: "Cycle",     
            UserHistoryTooltip: "Select this option to enable the employee's history for all of their managers",
            UserManagerTooltip: "Select this option for the person to appear as a manager in the employee profile listing",
            AccessDeniedContent: "You do not have access to this functionality",
            Assignment: "Assignment",
            DepartmentAssignmentBind: "Assignment linked in the department",
            DepartmentOld: "Previous department",
            AssignmentCurrent: "Current role",
            AssignmentOld: "Previous role",
            DevelopmentStageCurrent: "Current stage",
            DevelopmentStageFeedback: "Feedback stage",
            LoadingMessage0: "Starting the process...",
            LoadingMessage1: "Building parameters...",
            LoadingMessage2: "Compressing data...",
            LoadingMessage3: "Preparing credentials...",
            LoadingMessage4: "Sending request...",
            LoadingMessage5: "Receiving request...",
            LoadingMessage6: "Validating credentials...",
            LoadingMessage7: "Validating profile...",
            LoadingMessage8: "Decompressing data...",
            LoadingMessage9: "Validating format...",
            LoadingMessage10: "Fetching data...",
            LoadingMessage11: "Preparing to decrypt data...",
            LoadingMessage12: "Decrypting data...",
            LoadingMessage13: "Decrypting data...",
            LoadingMessage14: "Please wait while we decrypt the data...",
            LoadingMessage15: "Please wait while we decrypt the data...",
            LoadingMessage16: "Data successfully decrypted...",
            LoadingMessage17: "Processing and organizing data...",
            LoadingMessage18: "Compressing data...",
            LoadingMessage19: "Preparing the interface...",
            LoadingMessage20: "Preparing the interface...",            
        },  
        Es: {
            ApplicationName: "ISEFeedBack",
            Department: "Departamento",
            Departments: "Departamentos",
            DepartmentListWarning_0: "Departamentos aún no cargados",
            FeedbackPageHeader: "Período vigente",            
            Hiring: "Contratación",
            HiringDate: "Fecha de contratación",
            Contributor: "Colaborador",
            LastFeedBack: "Último feedback",
            FilledIn: "Completado",    
            MenuHeaderBlockMain: "Principal",
            MenuHeaderBlockReports: "Informes",
            MenuHeaderBlockAdministration: "Administración",
            MenuBind: "Vínculos Gestor-Colaborador",   
            MenuFeedbackScript: "Guía de feedback",
            MenuDashboard: "Panel de feedback",
            MenuFeedbackReport: "Informe de Feedbacks",
            HeaderPageBind: "Gestión de vínculos",
            Bind: "Vínculos",
            BindApproval: "Aprobación de vínculos",
            AdminPageHeader: "Gestión de perfil de usuario",
            ContentPageHeader: "Gestión de contenido",
            UserPageHeader: "Gestión de usuarios",
            DepartmentPageHeader: "Gestión de departamento",
            AssignmentPageHeader: "Gestión de asignación",            
            CyclePageHeader: "Gestión de Ciclos",
            PeriodLabelPageHeader: "Gestión de etiquetas de período",
            Cycles: "Ciclos",
            Periods: "Períodos",
            Period: "Período",
            PeriodStartDate: "Fecha de inicio del período",
            PeriodEndDate: "Fecha de finalización del período",            
            Stages: "Etapas",
            Stage: "Etapa",            
            DevelopmentStagePageHeader: "Gestión de etapas de desarrollo",
            Mentees: "Colaboradores",
            Mentors: "Gestores",
            Mentor: "Gestor",
            TableHeaderPersonData: "Datos de la persona",
            TableHeaderPersonMentorData: "Datos del Gestor",
            TableHeaderPersonMenteeData: "Datos del Colaborador",
            TableHeaderCycleData: "Dados del Ciclo",
            TableHeaderDevelopmentStageData: "Datos de la etapa de desarrollo",
            TableHeaderPeriodLabel: "Datos de la etiqueta del período",
            TableHeaderContentFeedback: "Datos del contenido del feedback",
            TableHeaderDepartmentData: "Datos del departamento",
            TableHeaderAssignmentData: "Detalles de la asignación",
            TableStateNotStarted: "No iniciado",
            ReferenceYear: "Año de referencia",
            PeriodDescription: "Descripción del período",
            ContentOrder: "Ordenación del contenido",
            WarningMessage0: "Seleccione un perfil para este registro antes de proceder",
            WarningMessage1: "Ingrese un nombre para este registro antes de proceder",
            WarningMessage2: "Ingrese un nombre para el período de este registro antes de proceder",
            WarningMessage3: "Seleccione una etiqueta de período para la búsqueda rápida que se aplique a la descripción de este registro antes de proceder",
            WarningMessage4: "Seleccione un estado para este período en este registro antes de proceder",            
            WarningMessage5: "La fecha de inicio es posterior a la fecha de finalización, corrija este registro con el nombre: $placeholder antes de proceder",
            WarningMessage6: "Ingrese un año para este registro antes de proceder",  
            WarningMessage7: "Seleccione una etiqueta de período para la búsqueda rápida que se aplique a la descripción de este registro antes de proceder",
            WarningMessage8: "Seleccione un departamento para este registro antes de proceder",            
            WarningMessage9: "Describa la función del colaborador",   
            WarningMessage10: "Describa el área del colaborador", 
            WarningMessage11: "Seleccione una fecha para este feedback", 
            WarningMessage12: "Seleccione un gestor responsable para este colaborador",
            WarningMessage13: "Seleccione una etapa de desarrollo del colaborador",
            WarningMessage14: "Seleccione una fecha de inicio para el empleado",            
            FieldSelectUser: "Seleccione un usuario",
            BindPageLabel0: "Seleccione los colaboradores para este gestor",
            BindPageLabel1: "Mismo departamento",
            BindPageLabel2: "Todos los de la organización",
            BindPageLabel3: "Personas vinculadas como colaboradores",
            Script: "Guía",
            Function: "Función",
            Area: "Área",
            ResponsibleMentor: "Gestor responsable",
            FeedbackFormDateFeed: "Fecha de la conversación",
            FeedbackFormHeader0: "Información general",
            FeedbackFormHeader1: "Percepciones del ciclo",
            FeedbackFormHeader2: "Plan de desarrollo",
            FeedbackFormHeader3: "Etapa actual de desarrollo",
            FeedbackFormHeader4: "Próximos pasos",
            FeedbackFormLabel0: "Percepciones del colaborador sobre el período",
            FeedbackFormLabel1: "Percepciones del gestor sobre el período",
            FeedbackFormLabel2: "Desarrollo formal, nuevos proyectos y objetivos para el próximo período",
            FeedbackFormLabel3: "Visible solo para el gestor",
            FeedbackFormLabel4: "Campo confidencial del gestor",
            FeedbackFormLabel5: "Este campo es privado y solo usted tiene acceso a él.",
            FeedbackFormLabel6: "Utilice este campo para describir la etapa de desarrollo actual del empleado, los puntos principales observados y los próximos pasos para su ascenso.",            
            FeedbackFormLabel7: "Comentarios de", 
            FeedbackFormLabel8: "Estágio anterior", 
            FeedbackFormLabel9: "Campo confidencial del gestor.", 
            FeedbackFormLabel10: "¿Desea exportar las notas privadas?",
            SelectDateLabel0: "Seleccione un dato de inicio", 
            SelectDateLabel1: "Selecciona un dato",
            ContentDisplayBlank: "Seleccione una opción para mostrar",
            PDFFeedBackFooterLabel0: "Documento generado para monitoreo interno.",
            PDFFeedBackFooterLabel1: "y desarrollo",
            TableNoOpenCycle: "No hay ningún ciclo abierto", 
            ReportPageHeader_0: "Panel de control operativo",    
            ReportPageLabel0: "Conclusión por departamento",  
            ReportPageLabel1: "Seleccione un ciclo antes de realizar la consulta",
            ReportPageLabel2: "No ha completado la sección de comentarios de los empleados",  
            ReportNotificationTemplate1: "Mensaje de retroalimentación de ISEFeedBack",
            ReportNotificationTemplate2: "El empleado |marcador de posición| no ha completado sus comentarios en nuestra plataforma",
            DepartmentCurrent: "Departamento actual",   
            Cycle: "Ciclo",   
            UserHistoryTooltip: "Seleccione esta opción para habilitar el historial del empleado para todos sus gerentes",
            UserManagerTooltip: "Seleccione esta opción para que la persona aparezca como gerente en la lista de perfiles de empleados.",                          
            AccessDeniedContent: "No tienes acceso a esta funcionalidad",
            Assignment: "Asignación",
            DepartmentAssignmentBind: "Asignación vinculadas en el departamento",
            DepartmentOld: "Departamento anterior",
            AssignmentCurrent: "Asignación actual",
            AssignmentOld: "Asignación anterior",
            DevelopmentStageCurrent: "Etapa de desarrollo actual",
            DevelopmentStageFeedback: "Etapa de desarrollo del feedback",           
            LoadingMessage0: "Iniciando el proceso...",
            LoadingMessage1: "Construyendo parámetros...",
            LoadingMessage2: "Comprimiendo los datos...",
            LoadingMessage3: "Preparando credenciales...",
            LoadingMessage4: "Enviando solicitud...",
            LoadingMessage5: "Recibiendo solicitud...",
            LoadingMessage6: "Validando credenciales...",
            LoadingMessage7: "Validando perfil...",
            LoadingMessage8: "Descomprimiendo los datos...",
            LoadingMessage9: "Validando formato...",
            LoadingMessage10: "Buscando los datos...",
            LoadingMessage11: "Preparando para descifrar los datos...",
            LoadingMessage12: "Descifrando los datos...",
            LoadingMessage13: "Descifrando los datos...",
            LoadingMessage14: "Espere mientras desciframos los datos...",
            LoadingMessage15: "Espere mientras desciframos los datos...",
            LoadingMessage16: "Datos descifrados correctamente...",
            LoadingMessage17: "Procesando y organizando los datos...",
            LoadingMessage18: "Comprimiendo los datos...",
            LoadingMessage19: "Preparando la interfaz...",
            LoadingMessage20: "Preparando la interfaz...",             
        }  
    }
};
